import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const DateContainer = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  flex-grow: 0;
`;

export const OccupancyContainer = styled.p`
  display: flex;
  margin: 0;
  flex-direction: column;
  flex-grow: 1;
  white-space: nowrap;

  ${media.xl`
    flex-grow: 0;
  `}
`;

export const RoomDetailsContainer = styled.div`
  display: none;
  ${media.xl`
  display: grid;
  grid-template-columns: calc(100% / 3) calc((100% / 3) * 2);
`}
`;

export const BasketItemRow = styled.div<{ isDesktop?: boolean; isMobile?: boolean }>`
  display: flex;
  width: 100%;
  padding: 5px 0;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      display: none;

      ${media.xl`
      display: inline-flex;
      align-items: center;
      width: 100%;
    `}
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      display: inline-flex;

      ${media.xl`
      display: none;
    `}
    `}
`;

export const BasketItemColumn = styled.div<{ isGrow?: boolean; alignSelf?: string }>`
  flex-grow: ${({ isGrow }) => (isGrow ? 1 : 0)};
  align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : 'initial')};
`;
